<template>
	<div class="page2warp">

		<!-- <div class="leaderBox">
			<div class="leadItem">

				<div class="name">
					<span>姓名</span>
					<span class="position overflowone">职位</span>
				</div>
				<div class="workbox">
					<div>工作单位：中国西安人才市场管理委员会办公室、陕西省人才交流服务中心</div>
					<div>工作单位职务：党委书记 主任</div>
				</div>
			</div>
		</div> -->
		<div class="detail-newscontent" v-if="contentObj">
			<div v-html="contentObj">

			</div>
		</div>
		<div v-else>
			<div class="emptyBox" style="paddingTop:20px">
				<img src="@/assets/imgs/branchempty.jpg" />
			</div>
		</div>
		<!-- <div class="pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			    :page-sizes="[5, 10, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div> -->

	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
	data() {
		return {
			srcUrl: srcUrl,
			currentPage: 1,
			pageSize: 100,
			contentObj: null
		}
	},
	mounted() {
		this.getNewsData()
	},
	methods: {
		async getNewsData() {
			let params = {
				pageSize: this.pageSize,
				pageCurrent: this.currentPage,
				pressSuperClass: 94,
			};
			let data = await httpService.getHeadList(params);
			if (data.code == 200) {
				if (data.result.list.length != 0) {
					this.contentObj = data.result.list[0]
				}
			}
		},
	}
}
</script>
<style lang="less" scoped>
.page2warp {
	width: 1200px;
	// margin: 0 auto;
	min-height: 400px;
	// padding: 20px 200px;
	.detail-newscontent {
		height: 600px;
		overflow-y: auto;
		padding: 20px 80px;
	}
	.leaderBox {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		.leadItem {
			width: 385px;
			height: 168px;
			box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
			box-sizing: border-box;
			border-radius: 8px;
			padding: 16px 20px 0 20px;
			margin: 30px 38px 0 0;
			&:nth-child(3n) {
				margin-right: 0;
			}

			.name {
				font-size: 18px;
				font-weight: bold;
				line-height: 30px;
				color: #448df7;
				margin-bottom: 10px;
				.position {
					font-size: 16px;
					line-height: 30px;
					color: #333333;
					margin-left: 6px;
				}
			}
			.workbox {
				font-size: 16px;
				line-height: 30px;
				color: #666666;
			}
		}
	}
	.emptyBox {
		img {
			width: 198px;
			height: 200px;
		}
	}
}
</style>


